module.exports = __webpack_public_path__ + "static/img/case01.71c299e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case01.png
// module id = 28
// module chunks = 0